import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectDVCPMATrackingForecastSubpage,
  selectDVCPMATrackingForecastTimeFrequency,
  setTimeFrequency as setTimeFrequencyRedux,
  setVariable,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
// import {
// useGetTrackingForecastTimeFrequenciesQuery
// } from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';
import useMockTimeFrequency from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useMockTimeFrequency';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';

export default function useTimeFrequency() {
  const subpage = useSelector(selectDVCPMATrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];
  // const { data, error } = useGetTrackingForecastTimeFrequenciesQuery({ submenu });
  const { data } = useMockTimeFrequency({ submenu });
  const timeFrequencies = data || [];

  const selectedTimeFrequencyValue: string | undefined = useSelector(
    selectDVCPMATrackingForecastTimeFrequency,
  );
  const selectedTimeFrequency = timeFrequencies.find(
    (tf) => tf.value === selectedTimeFrequencyValue,
  );
  const setTimeFrequency = (value: string) => {
    const timeFrequency = timeFrequencies.find((dt) => dt.value === value);
    if (timeFrequency) {
      store.dispatch(setTimeFrequencyRedux(value));
      // Reset variable when time frequency changes to trigger new variable fetch
      store.dispatch(setVariable(undefined));
    }
  };

  return { timeFrequencies, selectedTimeFrequency, setTimeFrequency };
}
